window.PointsEarningActivity = (function($, util) {
    window.dataLayer = window.dataLayer || [];
    let elements = null;
    window.addEventListener('DOMContentLoaded', function (){
        elements = window.PointsEarningConstants.elements;
    });
    let additionalFieldActivityCodes = $('#additionalInfoFields').val();
    let clientSideValidation = Boolean($('#clientSideValidation').val());
    let transformSpeed = 500;
    let vaccinesOption = 'VAX';
    let self = {
        urls: {
            metadataUrl: '/api/sitecore/PointsEarningActivitySubmitForm/SubmitData',
            errorPageUrl: '/error/error-page'
        },
        func: {
            init: function() {
                self.func.bindings();
                self.func.datePicker.setupDatePicker();
                self.func.datePicker.datePickerValidation();
                self.func.activityInformationForm.formValidation();
                self.func.activityInformationForm.checkbox.checkBoxValidation();
                self.func.activityInformationForm.additionalInfo.additionalInfoValidation();
            },
            bindings: function() { // Turn calendar pink when clicked
                $(elements.buttons.datePickerButtonTarget).on(elements.globalConstants.click,
                    function() {
                        $(this).closest(elements.classes.datePickerContainerTarget)
                            .find(elements.classes.datePickerInputTarget).focus();
                });
                $(elements.id.activitiesDropdownTarget).on(elements.globalConstants.change,
                    self.func.activityInformationForm.additionalInfo.additionalInformationFields
                );
                $(elements.id.activitiesDropdownTarget).on(elements.globalConstants.change,
                    self.func.activityInformationForm.activityWarningMessage
                );
                $(elements.id.vaccinationsDropdownTarget).on(elements.globalConstants.change,
                    self.func.activityInformationForm.vaccinationWarningMessage
                );
                $(elements.id.pointsEarningFormButtonTarget).on(elements.globalConstants.click,
                    self.func.activityInformationForm.submitForm
                );
                $(elements.classes.additionalInfoInputTarget).on(elements.globalConstants.blur,
                    self.func.activityInformationForm.additionalInfo.checkRegexOnAdditionalInfo
                );
                $(elements.classes.additionalInfoInputTarget).on(elements.globalConstants.blur,
                    self.func.activityInformationForm.additionalInfo.additionalInfoValidation
                );// Setup for vitality file uploader
                let handleUpload = event => {
                    let output = document.getElementById(elements.id.uploaderOutput);
                    output.innerText = JSON.stringify(event.detail);
                    let element = document.getElementById(elements.id.uploaderOutput);
                    let e = new Event(elements.globalConstants.change);
                    element.dispatchEvent(e);
                };
                let el = document.querySelector(elements.vitalityFileUploader);
                el.addEventListener(window.PointsEarningConstants.events.fileUploaded, handleUpload);
                // Prevent button clicks from accidentally submitting the form
                $(elements.classes.formTarget).on(elements.globalConstants.click, elements.button,
                    (event) => { event.preventDefault(); }
                );
                $(elements.id.uploaderOutputTarget).on(elements.globalConstants.change,
                    self.func.activityInformationForm.uploadValidationMessage
                );
            },
            datePicker: { //Sets up date picker to have the format and date range we need
                setupDatePicker: function() {
                    const monthsToGoBack = 6;
                    const dateFormat = elements.globalConstants.dateFormat;
                    let config = {
                        disableMobile: true, altInput: true,
                        minDate: new Date().setMonth(new Date().getMonth() - monthsToGoBack),
                        maxDate: new Date(), dateFormat: dateFormat, altFormat: dateFormat
                    };
                    let calendar = $(elements.id.pointsEarningDatepickerTarget).flatpickr(config);
                    let calendarButton = document.getElementById(elements.id.pointsEarningCalendarButton);
                    calendarButton.addEventListener(elements.globalConstants.click, function() {
                        calendar.open();
                    });
                    $(elements.id.pointsEarningDatepickerTarget).val(elements.globalConstants.emptyString);
                },
                //Events that validate a date has been picked
                //(having this in the bindings section doesnt work as it is above the date picker)
                datePickerValidation: function() {
                    if (clientSideValidation) {
                        const calTarget = elements.classes.flatpickrWindowTarget;
                        const datepickerTarget = elements.id.pointsEarningDatepickerTarget;
                        const calBtn = elements.id.pointsEarningCalendarButtonTarget;
                        self.func.datePicker.calendarButton(calBtn, datepickerTarget);
                        self.func.datePicker.calendarInput(calTarget, datepickerTarget)
                    }
                },
                calendarInput: function (calTarget, datepickerTarget) {
                    $(calTarget).on(elements.globalConstants.blur, function () {
                        let inputVal = $(datepickerTarget).val();
                        if(inputVal === elements.globalConstants.emptyString) {
                            self.func.datePicker.validateDatePicker($(this));
                        }
                    });
                    $(elements.classes.datePickerInputTarget).on(elements.globalConstants.blurChange, function (){
                        let calIsOpen = self.func.helpers.isItemState(calTarget, elements.globalConstants.visible)
                        if ($(datepickerTarget).val() === elements.globalConstants.emptyString && !calIsOpen) {
                            self.func.datePicker.validateDatePicker($(this));
                        } else {
                            $(elements.id.pointsEarningDatepickerParentTarget)
                                .removeClass(elements.classes.datePickerInvalid);
                            self.func.helpers
                                .hide(elements.id.datePickerIdTarget, elements.classes.itemRemoved);
                        }
                    });
                },
                calendarButton: function (calBtn, datepickerTarget) {
                    $(calBtn).on(elements.globalConstants.click, function () {
                        let btnClicked = false;
                        if ($(this).attr(elements.globalConstants.id) === elements.id.pointsEarningCalendarButton) {
                            btnClicked = true;
                        }
                        if($(datepickerTarget).val() === elements.globalConstants.emptyString && btnClicked === false) {
                            self.func.datePicker.validateDatePicker($(this));
                        }
                    });
                    $(calBtn).keydown(function(e) {
                        let code = e.keyCode || e.which;
                        const tabKey = 9;
                        let inputVal = $(datepickerTarget).val();
                        if (code === tabKey && inputVal === elements.globalConstants.emptyString) {
                            self.func.datePicker.validateDatePicker($(this));
                        }
                    });
                },
                validateDatePicker: function($this) {
                    let input = $this;
                    let identifier = elements.id.datePickerIdTarget;
                    let value = input.val();
                    if (value) {
                        $(elements.id.pointsEarningDatepickerParentTarget)
                            .removeClass(elements.classes.datePickerInvalid);
                        self.func.helpers.hide(identifier, elements.classes.itemRemoved);
                    } else {
                        $(elements.id.pointsEarningDatepickerParentTarget)
                            .addClass(elements.classes.datePickerInvalid);
                        self.func.helpers.show(identifier, elements.classes.itemRemoved);
                    }
                }
            },
            activityInformationForm: {
                //Both warning message functions control showing a warning message that matches the option
                //selected in the dropdown
                vaccinationWarningMessage: function() {
                    let value = $(elements.id.vaccinationsDropdownTarget + elements.globalConstants.selected).val();
                    if (self.func.helpers.isItemState(elements.id.vaccinationsDropdownWrapperTarget,
                        elements.globalConstants.visible)) {
                        self.func.helpers.warningMessage(
                            elements.classes.listOfVaccinationWarningsTarget,
                            value
                        );
                    } else {
                        return false;
                    }
                },
                activityWarningMessage: function() {
                    let value = $(elements.id.activitiesDropdownTarget + elements.globalConstants.selected).val();
                    if (value === vaccinesOption) {
                        self.func.helpers.hide(elements.classes.activityListWarningsTarget,
                            elements.classes.itemRemoved);
                    }
                    self.func.helpers.warningMessage(
                        elements.classes.listOfActivityWarningsTarget,
                        value
                    );
                }, //Validates all the inputs on the form. Showing or hiding validation messages
                formValidation: function() {
                    if (clientSideValidation) {
                        self.func.helpers.validate(
                            elements.classes.formValidationTarget,
                            elements.id.activitiesDropdownTarget
                        );
                        self.func.helpers.validate(
                            elements.id.vaccinationsDropdownTarget,
                            elements.id.vaccinationsDropdownWrapperTarget
                        );
                    }
                },
                validateForm: function($this) {
                    let input = $this;
                    let id = input.attr(elements.globalConstants.id);
                    let activityLocationValidation = 'activity-location';
                    let identifier = elements.globalConstants.hash + id + '-validation';
                    let value = input.val();
                    if (value && id !== activityLocationValidation) {
                        self.func.helpers.hide(identifier, elements.classes.itemRemoved);
                        input.removeClass(elements.classes.redErrorBoxForInputField);
                    } else if (id !== activityLocationValidation) {
                        self.func.helpers.show(identifier, elements.classes.itemRemoved);
                        input.addClass(elements.classes.redErrorBoxForInputField);
                    } else if (value && id === activityLocationValidation){
                        self.func.helpers.hide(identifier, elements.classes.itemInvisible);
                        input.removeClass(elements.classes.redErrorBoxForInputField);
                    } else if (id === activityLocationValidation) {
                        self.func.helpers.show(identifier, elements.classes.itemInvisible);
                        input.addClass(elements.classes.redErrorBoxForInputField);
                    }
                },
                additionalInfo: {
                    //Controls which field in the additional info section is at the top and making sure
                    //the first field is mandatory
                    additionalInformationFields: function() {
                        const firstAdditionalField = 0;
                        let currentSelectedVal = $(
                            elements.id.activitiesDropdownTarget + elements.globalConstants.selected).val();
                        let value = currentSelectedVal ?? $(this);
                        self.func.activityInformationForm.additionalInfo.toggleVaccinationDropdown(currentSelectedVal);
                        if (self.func.helpers.containsString(value, additionalFieldActivityCodes)) {
                            self.func.helpers.show(elements.id.additionalInfoFieldTarget,
                                elements.classes.itemRemoved);
                            $(elements.globalConstants.hash + value).each(function() {
                                $(this).parent().prepend(this);
                                //Keeps the two cholesterol fields together
                                $('#TCHR').append($('#HDLC'));
                                $(elements.classes.additionalInfoInputTarget)
                                    .removeClass(elements.classes.formValidation + ' ' +
                                        elements.classes.onSubmitValidation + ' ' + elements.classes.redErrorBoxForInputField);
                                $(elements.classes.additionalInfoInputTarget).eq(firstAdditionalField)
                                    .addClass(elements.classes.formValidation + ' ' + elements.classes.onSubmitValidation);
                                self.func.helpers.hide(elements.classes.additionalInfoFieldValidationTarget,
                                    elements.classes.itemRemoved);
                                $(elements.classes.additionalInfoInputTarget).val(elements.globalConstants.emptyString);
                            });
                            $(elements.id.additionalInfoFieldTitleTarget)
                                .prependTo(elements.id.additionalInfoFieldTarget);
                        } else {
                            self.func.helpers.hide(elements.id.additionalInfoFieldTarget,
                                elements.classes.itemRemoved);
                            $(elements.classes.additionalInfoInputTarget).val(elements.globalConstants.emptyString);
                            $(elements.classes.additionalInfoInputTarget).removeClass(elements.classes.onSubmitValidation
                                + ' ' + elements.classes.formValidation + ' ' + elements.classes.regexError
                                + ' ' + elements.classes.redErrorBoxForInputField);
                        }
                    },
                    //If vaccination is chosen as an activity the vaccine dropdown shows along with vaccine warnings
                    toggleVaccinationDropdown: function(value) {
                        if (value === vaccinesOption) {
                            self.func.helpers.show(elements.id.vaccinationsDropdownWrapperTarget,
                                elements.classes.itemRemoved);
                            self.func.helpers.show(elements.classes.listOfVaccinationWarningsTarget,
                                elements.classes.itemRemoved);
                            $(elements.id.vaccinationsDropdownTarget).addClass(
                                elements.classes.onSubmitValidation + ' ' + elements.classes.formValidation
                            );
                        } else {
                            self.func.helpers.hide(elements.id.vaccinationsDropdownWrapperTarget,
                                elements.classes.itemRemoved);
                            self.func.helpers.hide(elements.classes.listOfVaccinationWarningsTarget,
                                elements.classes.itemRemoved);
                            self.func.helpers.hide(elements.classes.vaccineWarnings, elements.classes.itemRemoved);
                            $(elements.id.vaccinationsDropdownTarget)
                                .removeClass(elements.classes.onSubmitValidation + ' ' +
                                    elements.classes.formValidation + ' ' + elements.classes.redErrorBoxForInputField);
                            $(elements.id.vaccinationsDropdownTarget).val(elements.globalConstants.emptyString);
                            self.func.helpers.hide(elements.id.vaccineValidationMessageTarget,
                                elements.classes.itemRemoved);
                        }
                    },
                    additionalInfoValidation: function() {
                        if (clientSideValidation) {
                            let $this = $(this);
                            self.func.activityInformationForm.additionalInfo.validateAdditionalInfo($this);
                        }
                    }, //The first field has to have something in it
                    validateAdditionalInfo: function($this) {
                        let isFirstAdditionalInfoInput = 1
                        let input = $this;
                        let firstChildElement = $(elements.id.additionalInfoFieldTarget)
                            .children()[isFirstAdditionalInfoInput];
                        let firstChildElementId = $(firstChildElement).attr(elements.globalConstants.id);
                        let inputParentId = $(input).parent().parent().attr(elements.globalConstants.id);
                        let isFirst = firstChildElementId === inputParentId;
                        if (isFirst && !input.val()) {
                            input.addClass(elements.classes.redErrorBoxForInputField + ' ' +
                                elements.classes.firstAdditionalInfoField);
                            self.func.helpers.showNextItem(elements.classes.firstAdditionalInfoFieldTarget);
                            $(elements.classes.firstAdditionalInfoFieldTarget)
                                .removeClass(elements.classes.firstAdditionalInfoField);
                        } else if (isFirst) {
                            input.addClass(elements.classes.firstAdditionalInfoField)
                                .removeClass(elements.classes.onSubmitValidation);
                            self.func.helpers.hideNextItem(elements.classes.firstAdditionalInfoFieldTarget);
                            $(elements.classes.firstAdditionalInfoFieldTarget)
                                .removeClass(elements.classes.firstAdditionalInfoField);
                        }
                    }, //None of the additional fields can have the wrong values in them
                    checkRegexOnAdditionalInfo: function() {
                        let input = $(this);
                        let value = input.val();
                        const regExPattern = 'pattern';
                        const allPossibleMatches = 'g';
                        let regex = new RegExp(input.attr(regExPattern), allPossibleMatches);
                        let patternMatch = regex.test(value);
                        if (value !== elements.globalConstants.emptyString && !patternMatch) {
                            input.addClass(elements.classes.redErrorBoxForInputField + ' ' + elements.classes.regexError);
                        } else {
                            input.removeClass(elements.classes.redErrorBoxForInputField + ' ' + elements.classes.regexError);
                        }
                    },
                },
                //When the correct file is uploaded a success message will show.
                //This checks that is visible before submission.
                uploadValidationMessage: function() {
                    const uploaderOutputValue = $(elements.id.uploaderOutputTarget).val();
                    if (uploaderOutputValue === '' || uploaderOutputValue === '[]') {
                        self.func.helpers.show(elements.id.pointsEarningUploadValidationMessageTarget,
                            elements.classes.itemRemoved);
                    } else {
                        self.func.helpers.hide(elements.id.pointsEarningUploadValidationMessageTarget,
                            elements.classes.itemRemoved);
                    }
                },
                checkbox: {
                    checkBoxValidation: function() {
                        if (clientSideValidation) {
                            $(elements.classes.checkboxInputTarget).on(elements.globalConstants.blurChange,
                                function() {
                                    self.func.activityInformationForm.checkbox.validateCheckbox();
                                }
                            );
                        }
                    }, //Checkbox needs to be checked before submission.
                    validateCheckbox: function() {
                        let isCheckboxChecked =
                            self.func.helpers.isItemState(elements.id.checkboxTarget, elements.globalConstants.checked);
                        if (!isCheckboxChecked) {
                            self.func.helpers.show(elements.id.checkboxValidationTarget,
                                elements.classes.itemInvisible);
                            $(elements.id.checkboxBoxTarget)
                                .addClass(elements.classes.redErrorBoxForCheckbox);
                        } else {
                            self.func.helpers.hide(elements.id.checkboxValidationTarget,
                                elements.classes.itemInvisible);
                            $(elements.id.checkboxBoxTarget).removeClass(elements.classes.redErrorBoxForCheckbox);
                            return true;
                        }
                    }
                }, //On submit this checks there are no validation errors
                validateOnSubmit: function() {
                    $(elements.classes.onSubmitValidationTarget).each(function() {
                        let input = $(this);
                        let id = input.attr(elements.globalConstants.id) ?? 'points-earning-activity-datepicker';
                        if (elements.globalConstants.hash + id === elements.id.pointsEarningDatepickerTarget) {
                            self.func.datePicker.validateDatePicker(input);
                        } else if (elements.globalConstants.hash + id !== elements.id.checkboxTarget) {
                            self.func.activityInformationForm.validateForm(input);
                            self.func.activityInformationForm.additionalInfo.validateAdditionalInfo(input);
                        } else {
                            return false;
                        }
                    });
                }, //Checks input fields and checkbox for validation errors. Then scrolls to the first one.
                hasValidationErrors: function() {
                    const uploaded = window.PointsEarningConstants.events.successfullyUploaded;
                    switch (true) {
                        case self.func.helpers.hasErrors(elements.classes.redErrorBoxForInputFieldTarget) ||
                        self.func.helpers.hasErrors(elements.classes.datePickerInvalidTarget):
                            self.func.activityInformationForm.scrollToError(elements.classes.redErrorBoxForInputFieldTarget + ', ' +
                                elements.classes.datePickerInvalidTarget, transformSpeed);
                            break;
                        case !self.func.helpers.containsString(uploaded, $(elements.id.uploaderOutputTarget).val()):
                            self.func.activityInformationForm.scrollToError(elements.id.pointsEarningUploadValidationMessageTarget, transformSpeed);
                            break;
                        case self.func.helpers.hasErrors(elements.classes.redErrorBoxForCheckboxTarget):
                            self.func.activityInformationForm.scrollToError(elements.classes.redErrorBoxForCheckboxTarget, transformSpeed);
                            break;
                        default:
                            break;
                    }
                }, //Determines where to scroll to in relation to the item identified as having an error
                scrollToError: function(identifier, speed) {
                    let id = $(identifier).first().attr(elements.globalConstants.id);
                    if (id === elements.id.checkboxBox) {
                        let distanceOffset = 110;
                        self.func.helpers.errorScroll(
                            elements.id.checkboxValidationTarget,
                            speed,
                            distanceOffset
                        );
                    } else {
                        $('html, body').animate(
                            {scrollTop: $(identifier).first().parent().offset().top},
                            speed
                        );
                    }
                }, //Controls whether the submit button does anything
                canSubmit: function() {
                    let additionalInfoError = self.func.helpers.hasClass(
                        elements.classes.additionalInfoInputTarget, elements.classes.onSubmitValidation);
                    let isCheckboxChecked = document.getElementById(elements.id.checkbox).checked;
                    let hasUploadedFile =
                        $(elements.id.uploaderOutputTarget).val().length >= elements.globalConstants.minimumValueLength;
                    let hasUploadFailed = self.func.helpers.containsString(elements.globalConstants.failed,
                        $(elements.id.uploaderOutputTarget).val());
                    let additionalInfoRegexError = self.func.helpers.hasClass(
                        elements.classes.additionalInfoInputTarget, elements.classes.regexError);
                    let errorCount = 0;
                    $(elements.classes.onSubmitValidationTarget).each(
                        function() {
                            let input = $(this);
                            if (input.val() === null || input.val() === elements.globalConstants.emptyString) {
                                errorCount = errorCount + 1;
                            }
                        });
                    return (
                        additionalInfoError === false && errorCount === 0 && isCheckboxChecked === true
                        && hasUploadFailed === false && hasUploadedFile === true && additionalInfoRegexError === false
                    );
                },
                submitForm: function(e) {
                    e.preventDefault();
                    const form = self.func.activityInformationForm;
                    // Perform client-side validation checks
                    form.checkbox.validateCheckbox();
                    form.validateOnSubmit();
                    form.hasValidationErrors();
                    form.uploadValidationMessage();
                    // Check if the form can be submitted
                    if (form.canSubmit()) {
                        // Prevent multiple click events
                        $(elements.id.pointsEarningFormButtonTarget)
                            .addClass(elements.classes.buttonDisabled);
                        $(elements.id.pointsEarningActivityForm).submit();
                    } else {
                        return false;
                    }
                }

            },
            redirectToErrorPage: function() {
                util.func.redirect(self.urls.errorPageUrl);
            },
            helpers: { //Hide siblings around selected item
                hideSiblings: function(identifier) {
                    $(identifier).siblings().addClass(elements.classes.itemRemoved);
                }, //Shows item next to selected item
                showNextItem: function(identifier) {
                    $(identifier).next().removeClass(elements.classes.itemRemoved);
                }, //Hides item next to selected item
                hideNextItem: function(identifier) {
                    $(identifier).next().addClass(elements.classes.itemRemoved);
                }, //Hides an item
                hide: function(identifier, loClass) {
                    $(identifier).addClass(loClass);
                }, //Shows an item
                show: function(identifier, loClass) {
                    $(identifier).removeClass(loClass);
                },
                errorScroll: function(identifier, speed, distanceOffset = 0) {
                    $('html, body').animate({
                            scrollTop: $(identifier).offset().top - distanceOffset
                        },
                        speed
                    );
                }, //Check state of item dependant on selector passed and gives a true or false result
                isItemState: function(identifier, selector) {
                    return !!$(identifier).is(selector)
                }, //Counts how many errors are on the page and returns false is greater than 0
                hasErrors: function(identifier) {
                    let noErrors = 0;
                    return $(identifier).length > noErrors;
                }, //Bool check for if a class is present or not
                hasClass: function(identifier, loClass) {
                    return !!$(identifier).hasClass(loClass);
                },
                validate: function(formTarget, dropdownTarget) {
                    $(formTarget).on(elements.globalConstants.blurChange, function() {
                        let currentSelectedVal = $(dropdownTarget + elements.globalConstants.selected).val();
                        let input = $(this) ?? currentSelectedVal;
                        self.func.activityInformationForm.validateForm(input);
                    });
                }, //Shows relevant warning and hides others
                warningMessage: function(target, value) {
                    $(target).each(function() {
                        const startOfId = '#activity-item-';
                        let currentItem = startOfId + value;
                        self.func.helpers.show(currentItem, elements.classes.itemRemoved);
                        self.func.helpers.hideSiblings(currentItem, transformSpeed);
                    });
                }, //Checks if string contains sub-string. Returns bool response
                containsString: function (string, value) {
                    let loValue = value.toLowerCase();
                    let loString = string.toLowerCase();
                    return loValue.includes(loString);
                }
            }
        }
    };
    return {
        init: self.func.init
    };
})(window.jQuery, window.Utilities);
$('document').ready(function() {
    if (window.Utilities.func.isComponentWithName('pea')) {
        window.PointsEarningActivity.init();
    }
});
